import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = (sctheme: any) => css`
  display: flex;
  flex-direction: column;
  height: 100vh;

  .wrapper {
    display: flex;
    flex-direction: column;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    flex: 1;
    min-height: 0;
    @media (max-width: 720px) {
      height: 100vh;
    }
    @media (min-width: 721px) {
      overflow: hidden;
    }
  }

  .layout {
    @media (max-width: 720px) {
      position: relative;
      top: var(--header-height, 62px);
      height: calc(100vh - var(--header-height, 62px));
    }
    @media (min-width: 721px) {
      display: flex;
      flex: 1;
      min-height: 0;
    }
    align-items: stretch;
  }

  .system-message {
    background-color: ${sctheme.blues.secondary};
    color: ${sctheme.white};
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid ${sctheme.white};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    &.mobile {
      display: none;
    }

    @media (max-width: 1200px) {
      display: none;

      &.mobile {
        display: flex;
        flex-direction: row;
        text-align: left;
        width: 100vw;
        min-height: 2rem;
      }
    }
  }
`;

export default styles(sctheme);
